import { render } from "./centerClinic.vue?vue&type=template&id=2d9de7dc"
import script from "./centerClinic.vue?vue&type=script&lang=js"
export * from "./centerClinic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__